export default __webpack_public_path__ + "796334fd0251bc785e2902f77704efc8.svg";